export const SHOPS_LOAD = "SHOPS_LOAD";
export const SHOPS_LOAD_REQUEST = "SHOPS_LOAD_REQUEST";
export const SHOPS_CLEAR = "SHOPS_CLEAR";
export const SHOPS_ADD = "SHOPS_ADD";
export const SHOPS_EDIT = "SHOPS_EDIT";
